/* most-buybox-b.js v11 (2026-09-25): + 2-Pack tier (60 days, no free-shipping claim), subscription card
   hidden when the selected pack has no selling plan. Rollback: re-upload v10 (Backups, outputs/most_cro).
   v10 (2026-08-28): + sticky bar state mirror.
   v9 (2026-08-21): units-first tier titles: pack-variant architecture.
   Pack option (1 Bottle / 3-Pack / 4-Pack) decorated as tier cards with live
   prices from the product data. Subscription checkbox reprices tiers from
   selling_plan_allocations. No quantity widget, no injected microcopy.
   Rollback: v4/v3/v2/v1 in outputs/most_cro. */
(function () {
  var HANDLE = 'most-hair-fibers';
  var UPSELLS = [
    { handle: 'precision-applicator', subtitle: 'A focused nozzle for hairlines, temples and beards' }
  ];
  var PDATA = null, tries = 0;

  /* 2026-09-18, launch: local currencies are on (EUR / GBP / AUD / CAD ...). Product JSON
     already arrives in the visitor's currency, so only the SYMBOL and decimal style were
     wrong - this used to hardcode "$". Mirrors Shopify's default formats for the currencies
     the store sells in; anything else falls back to "CODE 12.34". */
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var n = c / 100;
    var comma = { EUR: 1, DKK: 1, NOK: 1, SEK: 1, PLN: 1, CZK: 1, HUF: 1, RON: 1 };
    var s = n.toFixed(2); if (comma[cur]) s = s.replace('.', ',');
    var pre = { USD: '$', CAD: 'CA$', AUD: 'A$', NZD: 'NZ$', SGD: 'S$', HKD: 'HK$', GBP: '\u00a3', EUR: '\u20ac', JPY: '\u00a5', ILS: '\u20aa', KRW: '\u20a9', CHF: 'CHF ', PLN: 'z\u0142 ', CZK: 'K\u010d ', HUF: 'Ft ', RON: 'lei ', MYR: 'RM ', AED: 'AED ', INR: '\u20b9' };
    var post = { DKK: ' kr', NOK: ' kr', SEK: ' kr' };
    if (cur === 'JPY' || cur === 'KRW') s = String(Math.round(n));
    if (pre[cur] != null) return pre[cur] + s;
    if (post[cur] != null) return s + post[cur];
    return cur + ' ' + s;
  }

  function boot() {
    var t = setInterval(function () {
      tries++;
      var pack = document.querySelector('select[name="options[Pack]"]');
      var aw = document.querySelector('.appstle_sub_widget');
      if (!pack || !aw) { if (tries > 60) clearInterval(t); return; }
      clearInterval(t);
      fetch('/products/' + HANDLE + '.js').then(function (r) { return r.json(); })
        .then(function (p) { PDATA = p; init(); })
        .catch(function () {});
    }, 400);
  }

  function vmap() {
    var m = {};
    (PDATA.variants || []).forEach(function (v) {
      var shade = v.option1, pk = v.option2;
      m[shade] = m[shade] || {};
      var sub = null;
      (v.selling_plan_allocations || []).forEach(function (a) { if (sub === null || a.price < sub) sub = a.price; });
      /* Appstle fixed selling-plan prices are the checkout prices. No display offsets. */
      var ot = v.price; /* one-time charged price */
      m[shade][pk] = { id: v.id, price: ot, cmp: v.compare_at_price, sub: sub };
    });
    return m;
  }

  function init() {
    var MAP = vmap();
    function shade() { var c = document.querySelector('input[name="Shade"]:checked'); return c ? c.value : 'Black'; }
    function subOn() { var r = document.querySelector('input[name="selling_plan"]:checked'); return !!(r && r.value); }

    /* Pack renders as a native <select>: hide it, build custom tier cards.
       Only the fibers product has a Pack option. On the accessory pages there is no
       select, so bail out and leave the theme's own price and buy box alone. */
    var sel = document.querySelector('select[name="options[Pack]"]');
    if (!sel) return;
    document.documentElement.classList.add('most-tiers-on');
    var selWrap = sel.closest('.product-form__input') || sel.parentElement;
    selWrap.style.display = 'none';
    var packWrap = document.createElement('div');
    packWrap.className = 'most-pack-tiers';
    var head = document.createElement('div');
    head.className = 'most-hr-head most-pack-head';
    head.textContent = 'Bundle & save';
    selWrap.parentNode.insertBefore(head, selWrap);
    selWrap.parentNode.insertBefore(packWrap, selWrap);
    var PACKS = ['1 Bottle', '2-Pack', '3-Pack', '4-Pack'];
    var UNITS = { '1 Bottle': 1, '2-Pack': 2, '3-Pack': 3, '4-Pack': 4 };
    PACKS.forEach(function (pk) {
      var lab = document.createElement('label');
      lab.className = 'most-tier';
      lab.setAttribute('data-pack', pk);
      var tname = pk === '1 Bottle' ? '1 BOTTLE' : (pk === '2-Pack' ? '2 BOTTLES' : (pk === '3-Pack' ? '3 BOTTLES' : '4 BOTTLES'));
      var tcap = pk === '1 Bottle' ? '30 days' : (pk === '2-Pack' ? '60 days' : (pk === '3-Pack' ? '90 days · Free shipping' : '120 days · Free shipping'));
      var chip = pk === '3-Pack' ? '<span class="most-tier-chip">Most Popular</span>' : (pk === '4-Pack' ? '<span class="most-tier-chip most-tier-chip--alt">Best Value</span>' : '');
      lab.innerHTML = '<input type="radio" name="most-pack" value="' + pk + '"' + (sel.value === pk ? ' checked' : '') + '>' +
        '<span class="most-tier-main"><span class="most-tier-name">' + tname + '</span>' +
        '<span class="most-tier-cap">' + tcap + '</span></span>' +
        '<span class="most-tier-price"></span>' + chip;
      lab.querySelector('input').addEventListener('change', function () {
        if (sel.value !== pk) { sel.value = pk; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      packWrap.appendChild(lab);
    });
    /* handoff 5.2: header, subhead, honest rating line under the product title */
    (function(){
      var titleEl = document.querySelector('.product__title, h1');
      if (titleEl && !document.querySelector('.most-card-header')) {
        var w=document.createElement('div');
        w.innerHTML='<p class="most-card-header">Thicker-looking hair in 30 seconds. Undetectable at arm\'s length.</p>'+
          '<p class="most-card-sub">most. fills in thinning areas with fibers that anchor to your own hair. No one sees the product. They just see more hair.</p>';
        titleEl.parentNode.insertBefore(w, titleEl.nextSibling);
      }
      var shadeInp=document.querySelector('input[name="Shade"]');
      if (shadeInp && !document.querySelector('.most-shade-help')) {
        var fs=shadeInp.closest('fieldset')||shadeInp.parentElement;
        var h=document.createElement('p'); h.className='most-shade-help';
        h.textContent='Between two shades? Go darker. Darker blends in, lighter shows. Free shade swaps, forever. 30-day money-back guarantee.';
        fs.parentNode.insertBefore(h, fs.nextSibling);
      }
      
      /* 4th seal: Free Shade Swap (spec row: guarantee / discreet / 24h / swap) */
      try {
        var iconRow=document.querySelector('.product__info-wrapper .icon-with-text, .product__info-wrapper [class*="icon-with-text"]');
        if (iconRow && !iconRow.querySelector('.most-seal-swap')) {
          var items=iconRow.children;
          if (items.length===3) {
            var clone=items[0].cloneNode(true);
            clone.classList.add('most-seal-swap');
            var hEls=clone.querySelectorAll('h1,h2,h3,h4,p,span');
            for (var hz=0;hz<hEls.length;hz++){ if(/60|Guarantee/i.test(hEls[hz].textContent)){ hEls[hz].textContent='Free Shade Swap'; } }
            iconRow.appendChild(clone);
          }
        }
      } catch(e){}
      var addBtns=document.querySelectorAll('button[name="add"]');
      if (addBtns.length && !document.querySelector('.most-cta-micro')) {
        var last=addBtns[0];
        var mc=document.createElement('p'); mc.className='most-cta-micro';
        mc.textContent='Free shade swaps, forever. 30-day guarantee, we pay the return shipping.';
        last.parentNode.insertBefore(mc, last.nextSibling);
      }
    })();

    /* handoff 5.2 kit upgrade: Starter Ritual swap */
    var RITUAL={};
    fetch('/products/starter-ritual.js').then(function(r){if(!r.ok)throw 0;return r.json();}).then(function(p){
      p.variants.forEach(function(v){ RITUAL[v.option1]=v.id; });
      if (document.querySelector('.most-kit-card')) return;
      var kc=document.createElement('label'); kc.className='most-kit-card';
      kc.innerHTML='<input type="checkbox" id="most-kit-check"><span><strong>Make it the full ritual:</strong> swap to the Starter Ritual with your preferred hairspray and the applicator \u00b7 $49.95, $19.90 off</span>';
      var cardEl=document.querySelector('.most-sub-card');
      if (cardEl) cardEl.parentNode.insertBefore(kc, cardEl.parentNode.querySelector('.most-upsells') || cardEl.nextSibling);
      kc.querySelector('input').addEventListener('change', function(){
        var on=this.checked;
        document.documentElement.classList.toggle('most-kit-active', on);
        if (on && check.checked) setPlan(false);
      });
    }).catch(function(){});

    sel.addEventListener('change', function () {
      var r = packWrap.querySelector('input[value="' + sel.value + '"]');
      if (r && !r.checked) r.checked = true;
      decorate();
    });

    function decorate() {
      /* 2026-09-25: Appstle re-renders its plan radios on every variant change and lands on
         one-time when the previous pack had no plan (2-Pack today). If the customer's
         subscription box is still ticked and the new pack has a plan, re-select the plan
         so the box, the prices and the cart stay in agreement. */
      try {
        var dcur = (MAP[shade()] || {})[selectedPack()];
        if (dcur && dcur.sub != null && typeof check !== 'undefined' && check && check.checked && !subOn()) {
          var subR = planRadios().filter(function (r) { return r.value; })[0];
          if (subR) { subR.checked = true; subR.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      } catch (e) {}
      var on = subOn(), sh = shade();
      PACKS.forEach(function (pk) {
        var lab = packWrap.querySelector('label[data-pack="' + pk + '"]');
        var d = (MAP[sh] || {})[pk];
        if (!lab || !d) return;
        var main = on && d.sub != null ? d.sub : d.price;
        var strike = on && d.sub != null ? d.price : d.cmp;
        /* unit price 2026-08-31: lead with the per-bottle price, total underneath.
           Single bottle keeps a plain price, since "each" and "total" are the same number. */
        var n = UNITS[pk] || 1;
        var eachNow = money(Math.round(main / n));
        var eachWas = strike ? money(Math.round(strike / n)) : '';
        var ea = n > 1 ? '<span class="most-tier-ea">each</span>' : '';
        /* 2026-09-07: two lines only. Price per bottle, then the struck single-bottle price.
           No total, no per-day (Carlos: too much information). The sticky bar still shows the total. */
        lab.querySelector('.most-tier-price').innerHTML =
          '<span class="most-tier-now">' + eachNow + ea + '</span>' +
          (eachWas ? '<s>' + eachWas + '</s>' : '');
      });
      savingsLabel(sh);
      try { if (typeof renderMix === 'function') renderMix(); } catch (e) {}
      try { stickyRender(); } catch (e) {}
    }

    /* Keep the subscription message consistent across bundle selections. */
    function selectedPack() {
      var r = packWrap.querySelector('input[name="most-pack"]:checked');
      return r ? r.value : (sel ? sel.value : '1 Bottle');
    }
    function savingsLabel(sh) {
      var d = (MAP[sh] || {})[selectedPack()];
      var head = document.getElementById('most-sub-head');
      var perk = document.getElementById('most-sub-pct');
      /* 2026-09-25: a pack with no selling plan (for example a 2-Pack before its Appstle plan exists)
         hides the subscription card instead of showing a checkbox that does nothing. */
      try {
        var noPlan = !d || d.sub == null;
        var cardWrap = document.querySelector('.most-sub-card');
        var cardHead = document.getElementById('most-sub-head');
        /* .most-hr-head carries display:flex !important, so inline display loses; use hidden + setProperty. */
        if (cardWrap) cardWrap.style.setProperty('display', noPlan ? 'none' : '', noPlan ? 'important' : '');
        if (cardHead) cardHead.style.setProperty('display', noPlan ? 'none' : 'flex', 'important');
      } catch (e) {}
      if (!d || d.sub == null || !d.price) return;
      if (head) head.innerHTML = 'Subscribe &amp; save 25%';
      if (perk) perk.textContent = '25% off every recurring order';
    }

    /* subscription card */
    var card = document.createElement('div');
    card.innerHTML =
      '<div class="most-hr-head" id="most-sub-head">Subscribe &amp; save</div>' +
      '<div class="most-sub-card"><label class="row">' +
      '<input type="checkbox" id="most-sub-check">' +
      '<span class="t">Delivered to you every month</span></label>' +
      '<ul class="most-sub-perks">' +
      '<li id="most-sub-pct">Discounted on every recurring order</li>' +
      '<li>Applies to whatever you select above</li>' +
      '<li>Cancel or pause anytime</li></ul></div>';
    packWrap.parentNode.insertBefore(card, packWrap.nextSibling);
    var check = card.querySelector('#most-sub-check');

    /* ---- mix shades 2026-09-07: on a 3 or 4 pack, one shade per bottle.
       Bottle 1 is the Shade picked above (two-way synced). Bottles 2 to N get a compact select.
       Choices travel as line item properties "Bottle 1..N" on the pack line, so the price, the variant,
       the subscription plan and the discounts are untouched. Fulfilment reads the properties.
       Rollback: delete this block and the CSS marked "mix shades". ---- */
    var SHADES = (function () {
      var o = (PDATA.options || []).filter(function (x) { return (x.name || x) === 'Shade'; })[0];
      return (o && o.values) ? o.values.slice() : ['Black', 'Dark Brown', 'Light Brown', 'Blonde'];
    })();
    var mix = document.createElement('div');
    mix.className = 'most-mix';
    mix.innerHTML =
      '<label class="most-mix-row">' +
        '<span class="most-mix-txt"><span class="most-mix-t">Mix shades</span>' +
        '<span class="most-mix-s">One shade per bottle</span></span>' +
        '<input type="checkbox" id="most-mix-check"><span class="most-switch" aria-hidden="true"></span>' +
      '</label>' +
      '<div class="most-mix-list"></div>';
    card.parentNode.insertBefore(mix, card);
    var mixCheck = mix.querySelector('#most-mix-check');
    var mixList = mix.querySelector('.most-mix-list');
    var bottles = [];  /* shades for bottles 2..N, index 0 = bottle 2 */
    var pform = (function () {
      var fs = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      /* 2026-09-12: the installment form also carries input[name=id] and comes first in the DOM.
         Pick the form that actually has the Add to cart button, or sits inside <product-form>. */
      return fs.filter(function (f) { return f.querySelector('button[name="add"]') || f.closest('product-form'); })[0]
          || fs.filter(function (f) { return f.querySelector('input[name="id"]'); })[0] || fs[0] || null;
    })();
    var propBox = null;
    if (pform) { propBox = document.createElement('div'); propBox.className = 'most-mix-props'; pform.appendChild(propBox); }

    function mixUnits() { return UNITS[selectedPack()] || 1; }
    function mixActive() { return mixCheck.checked && mixUnits() > 1; }
    function shadeSelect(idx, val, locked) {
      var s = '<select data-bottle="' + idx + '"' + (locked ? ' data-first="1"' : '') + ' aria-label="Shade for bottle ' + idx + '">';
      SHADES.forEach(function (sh) { s += '<option value="' + sh + '"' + (sh === val ? ' selected' : '') + '>' + sh + '</option>'; });
      return s + '</select>';
    }
    function buildMixList() {
      var n = mixUnits(), sh = shade();
      while (bottles.length < n - 1) bottles.push(sh);
      bottles.length = Math.max(0, n - 1);
      var html = '<label class="most-mix-item"><span class="most-mix-b">Bottle 1</span>' + shadeSelect(1, sh, true) + '</label>';
      for (var i = 2; i <= n; i++) {
        html += '<label class="most-mix-item"><span class="most-mix-b">Bottle ' + i + '</span>' + shadeSelect(i, bottles[i - 2], false) + '</label>';
      }
      mixList.innerHTML = html;
    }
    function syncMixProps() {
      if (!propBox) return;
      propBox.innerHTML = '';
      if (!mixActive()) return;
      var n = mixUnits(), all = [shade()].concat(bottles.slice(0, n - 1));
      all.forEach(function (sh, i) {
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[Bottle ' + (i + 1) + ']'; inp.value = sh;
        propBox.appendChild(inp);
      });
    }
    function renderMix() {
      var n = mixUnits();
      mix.style.display = n > 1 ? '' : 'none';
      mix.classList.toggle('is-mixing', mixActive());
      if (n > 1) buildMixList();
      syncMixProps();
    }
    mixCheck.addEventListener('change', function () { renderMix(); try { stickyRender(); } catch (e) {} });
    mixList.addEventListener('change', function (e) {
      var s = e.target; if (!s || s.tagName !== 'SELECT') return;
      var idx = parseInt(s.getAttribute('data-bottle'), 10);
      if (idx === 1) {
        var r = document.querySelector('input[name="Shade"][value="' + s.value + '"]');
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      } else { bottles[idx - 2] = s.value; }
      syncMixProps();
      try { stickyRender(); } catch (e) {}
    });
    renderMix();

    function planRadios() { return Array.prototype.slice.call(document.querySelectorAll('input[name="selling_plan"]')); }
    function setPlan(on) {
      var radios = planRadios();
      var sub = radios.filter(function (r) { return r.value; })[0];
      var one = radios.filter(function (r) { return !r.value; })[0];
      if (on && sub) { sub.checked = true; sub.dispatchEvent(new Event('change', { bubbles: true })); }
      else if (one) { one.checked = true; one.dispatchEvent(new Event('change', { bubbles: true })); }
      apply();
    }
    function apply() {
      var on = subOn();
      document.documentElement.classList.toggle('most-sub-active', on);
      if (check.checked !== on) check.checked = on;
      decorate();
    }
    check.addEventListener('change', function () { setPlan(check.checked); });
    document.addEventListener('change', function (e) {
      if (!e.target) return;
      if (e.target.name === 'selling_plan') setTimeout(apply, 60);
      if (e.target.name === 'Shade' || e.target.name === 'most-pack') { setTimeout(decorate, 60); setTimeout(decorate, 450); }
    });
    apply();
    /* 2026-09-19: Shopping advertises the one-time variant price.
       Preserve the feed offer on arrival; customers can still opt into a subscription. */
    var arrival = new URLSearchParams(window.location.search);
    /* 2026-09-21: any paid Google arrival (Search cpc, Shopping, Demand Gen) lands on the one-time offer. */
    var googleShoppingArrival = arrival.get('utm_source') === 'google' &&
      (arrival.get('utm_medium') === 'product_sync' ||
       arrival.get('utm_medium') === 'cpc' ||
       arrival.get('utm_campaign') === 'most_shopping_launch_20260919') ||
      arrival.has('gclid') || arrival.has('gbraid') || arrival.has('wbraid');
    var oneTimeArrival = googleShoppingArrival || arrival.get('purchase_option') === 'one_time';
    setTimeout(function () {
      if (oneTimeArrival) setPlan(false);
      else if (!check.checked) setPlan(true);
    }, 150);


    /* ------------------------------------------------------------------
       Sticky add to cart, 2026-08-28. Mirrors the buy box state exactly:
       shade, pack, supply window and the price actually charged. The theme's
       own title and price render the raw variant price, which is not what the
       cart charges once the plan and the automatic discount apply, so both are
       hidden in CSS and replaced here. The theme's button is left alone so the
       form submit, the upsell interception and the kit swap keep working.
       Rollback: delete this block and the CSS marked "sticky bar 2026-08-28".
       ------------------------------------------------------------------ */
    var SWATCH = { 'Black':'#1a1512', 'Dark Brown':'#3a2317', 'Light Brown':'#7a5636', 'Blonde':'#b5915c' };
    var PACKNAME = { '1 Bottle':'1 bottle', '2-Pack':'2 bottles', '3-Pack':'3 bottles', '4-Pack':'4 bottles' };
    var PACKDAYS = { '1 Bottle':'30 days', '2-Pack':'60 days', '3-Pack':'90 days', '4-Pack':'120 days' };
    var RITUAL_PRICE = 4995, RITUAL_CMP = 6985;

    function stickyMount() {
      var host = document.querySelector('sticky-atc .sticky-atc__left__content');
      if (!host) return null;
      var bar = host.querySelector('.most-sb');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'most-sb';
        bar.innerHTML =
          '<span class="most-sb-sw" aria-hidden="true"></span>' +
          '<span class="most-sb-meta">' +
            '<span class="most-sb-l1"></span>' +
            '<span class="most-sb-l2"><span class="most-sb-pill"></span></span>' +
          '</span>' +
          '<span class="most-sb-px">' +
            '<span class="most-sb-now"></span>' +
            '<span class="most-sb-was"></span>' +
          '</span>';
        host.appendChild(bar);
        document.documentElement.classList.add('most-sb-on');
      }
      return bar;
    }

    function stickyRender() {
      var bar = stickyMount();
      if (!bar) return;
      var kit = document.querySelector('#most-kit-check');
      var sh = shade();
      var q = function (c) { return bar.querySelector(c); };

      q('.most-sb-sw').style.background = SWATCH[sh] || '#1a1512';

      var l1, pill, now, was;
      if (kit && kit.checked) {
        l1 = 'Starter Ritual · ' + sh;
        pill = '3 pieces';
        now = RITUAL_PRICE; was = RITUAL_CMP;
      } else {
        var pk = selectedPack();
        var d = (MAP[sh] || {})[pk];
        if (!d) return;
        var on = subOn();
        l1 = sh + ' · ' + (PACKNAME[pk] || pk);
        try { if (typeof mixActive === 'function' && mixActive()) l1 = 'Mixed shades · ' + (PACKNAME[pk] || pk); } catch (e) {}
        pill = PACKDAYS[pk] || '';
        now = on && d.sub != null ? d.sub : d.price;
        was = on && d.sub != null ? d.price : d.cmp;
      }

      q('.most-sb-l1').textContent = l1;
      q('.most-sb-pill').textContent = pill;
      q('.most-sb-pill').style.display = pill ? '' : 'none';
      /* unit price 2026-08-31: the bar mirrors the tier cards. Multi-packs lead with the
         per-bottle price and put the charged total on the second line. */
      var units = (kit && kit.checked) ? 1 : (UNITS[selectedPack()] || 1);
      var wasEl = q('.most-sb-was');
      if (units > 1) {
        q('.most-sb-now').innerHTML = money(Math.round(now / units)) + '<span class="most-tier-ea">each</span>';
        wasEl.textContent = 'Total ' + money(now);
        wasEl.classList.remove('is-strike');
        wasEl.style.display = '';
      } else {
        q('.most-sb-now').textContent = money(now);
        if (was && was > now) { wasEl.textContent = money(was); wasEl.classList.add('is-strike'); wasEl.style.display = ''; }
        else { wasEl.textContent = ''; wasEl.classList.remove('is-strike'); wasEl.style.display = 'none'; }
      }
    }

    /* The theme injects the bar after its own scroll handler runs, so poll
       briefly on load, then render on every state change. */
    (function () {
      var n = 0;
      var iv = setInterval(function () {
        n++;
        if (document.querySelector('sticky-atc .sticky-atc__left__content')) { stickyRender(); clearInterval(iv); }
        if (n > 40) clearInterval(iv);
      }, 250);
      document.addEventListener('change', function (e) {
        if (!e.target) return;
        var nm = e.target.name || e.target.id || '';
        if (nm === 'Shade' || nm === 'most-pack' || nm === 'selling_plan' || nm === 'most-kit-check') {
          setTimeout(stickyRender, 80);
        }
      });
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.most-tier, .most-kit-card, .most-sub-card')) {
          setTimeout(stickyRender, 120);
        }
      });
    })();

    /* upsells */
    var wrap = document.createElement('div'); wrap.className = 'most-upsells';
    var uhead = document.createElement('div'); uhead.className = 'most-hr-head';
    uhead.textContent = 'Recommended for better results';
    var any = false;
    UPSELLS.forEach(function (u) {
      fetch('/products/' + u.handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        if (!p.available) throw 0;
        if (!any) { card.parentNode.insertBefore(uhead, card.nextSibling); card.parentNode.insertBefore(wrap, uhead.nextSibling); any = true; }
        var v = p.variants[0];
        var row = document.createElement('label'); row.className = 'most-upsell';
        row.innerHTML = '<input type="checkbox" data-upsell-id="' + v.id + '">' +
          (p.featured_image ? '<img src="' + p.featured_image + '&width=104">' : '') +
          '<span class="mid"><span class="t">' + p.title + '</span>' +
          '<span class="s">' + (u.subtitle || '') + '</span></span>' +
          '<span class="p">' + money(v.price) + '</span>';
        wrap.appendChild(row);
      }).catch(function () {});
    });
    var bypass = false;
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
      if (bypass) { bypass = false; return; }
      var ids = Array.prototype.slice.call(document.querySelectorAll('[data-upsell-id]:checked'))
        .map(function (c) { return parseInt(c.getAttribute('data-upsell-id'), 10); });
      var kit = document.querySelector('#most-kit-check');
      if (kit && kit.checked) {
        var sh = (document.querySelector('input[name="Shade"]:checked')||{}).value || 'Black';
        var rid = RITUAL[sh];
        if (rid) {
          e.preventDefault(); e.stopImmediatePropagation();
          var items=[{id:rid,quantity:1}].concat(ids.map(function(id){return {id:id,quantity:1};}));
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
            .finally(function(){ window.location='/cart'; });
          return;
        }
      }
      if (!ids.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      }).finally(function () { bypass = true; f.requestSubmit ? f.requestSubmit() : f.submit(); });
    }, true);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
